<template>
    <div class="check-steps-list">

        <FirstStep v-if="currentStep >= 1" :steps="steps.firstStep" :passed="currentStep !== 1" @stepChanged="stepChanged"/>

        <SecondStep v-if="currentStep > 1" :steps="steps.secondStep" :passed="currentStep !== 2" @stepChanged="stepChanged"/>

        <ThirdStep v-if="currentStep > 2" :addresseeList="addresseeList"/>
    </div>
</template>

<script>
import FirstStep from "@/components/blocks/FirstStep";
import SecondStep from "@/components/blocks/SecondStep";
import ThirdStep from "@/components/blocks/ThirdStep";
import router from "../../router";

export default {
    name: "ClientCheck",
    props: ['stepsInitial', 'currentStepInitial', 'addresseeList'],
    components: {ThirdStep, SecondStep, FirstStep},
    data() {
        return {
            currentStep: this.currentStepInitial,
            steps: this.stepsInitial
        }
    },

    watch: {
        currentStepInitial() {
            this.currentStep = this.currentStepInitial;
        },
        stepsInitial() {
            this.steps = this.stepsInitial;
        }
    },

    methods: {
        stepChanged(step) {
            this.currentStep = step;

            if (step === 1) {
                this.steps = {
                    firstStep: [],
                    secondStep: [],
                    thirdStep: []
                }
            }

            if (step === 3) {
                this.$emit('statusChanged', 'waitSend');
            }

            if (step === 0) {
                this.$emit('statusChanged', 'notSubscribed');
                router.push("/clients");
            }
        }
    }
}
</script>

<style scoped>

</style>